import {computed, Injectable, Optional} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ToastrWrapperService} from '../../../../shared/services/toastr-wrapper.service';
import {AssetApi} from '../api/asset.api';
import {Asset, AssetSection} from '../models/asset.model';
import {AssetsRequest} from '../models/assets-request.model';
import {AssetState} from '../state/asset.state';
import {Router} from '@angular/router';
import {environment} from '../../../../../../environments/environment';
import {SubmitType} from '../../../../shared/models/submit.type';
import {PermissionsService} from '../../../../shared/components/permissions/services/permissions.service';
import {DashboardGroupInfo} from '../models/dashboard-group-info.model';
import {TabType} from '../models/tab-type.type';
import {DashboardGroup} from '../models/dashboard-group.model';
import {WelcomeMessageModel} from '../models/welcomeMessage.model';
import { catchError, map } from 'rxjs/operators';
import { DataSourceExplore } from '../models/dataSource-explore.model';
import { AssetsMetaData, AssetMetaDataPayload } from '../models/assets-meta-data.model';
import { DataSourceUploadProgressService } from '../../../../data-source/services/data-source-upload-progress.service';
import { SortOrder } from '../../../../shared/models/sort.order';
import { Workspace } from '../../../../shared/models/work-space.model';
import { MessageDialogComponent } from '../../../../shared/components/message-dialog/message-dialog.component';
import { NbDialogService } from '@nebular/theme';
import { ExportWarningModalComponent } from '../../../../dashboard/components/dialogs/export-warning-modal/export-warning-modal.component';
@Injectable({
    providedIn: 'root',
})

export class AssetFacade {
    baseAddress = environment.api + '/File/Download?path=';

    constructor(
        private assetApi: AssetApi,
        @Optional() private dialogService: NbDialogService,
        private assetState: AssetState,
        private toastr: ToastrWrapperService,
        private permissionsService: PermissionsService,
        private progressService: DataSourceUploadProgressService,
        private router: Router) {
    }
    readonly state = computed(() => ({
        dashboardNameDuplicated: this.assetState.dashboardNameDuplicated(),
    
      }));
    

    loadExploreAssets(loadingAssets: AssetsRequest, type: TabType): void {
        this.assetState.updatePageNumber(loadingAssets.pageNumber);
        switch (type) {
            case 'All':
                this.loadAllExploreAssets(loadingAssets);
                break;
            case 'Dashboard':
                this.loadDashboardExploreAssets(loadingAssets);
                break;
            case 'DataSource':
                this.loadDatasourceExploreAssets(loadingAssets);
                break;
            case 'DashboardGroup':
                this.loadDashboardGroupExploreAssets(loadingAssets);
                break;
        }
    }

    loadAllExploreAssets(loadingAssets: AssetsRequest) {
        this.permissionsService.loadAllAssets$(loadingAssets).subscribe(
            (data) => {
                if (loadingAssets.needCount) {
                    this.assetState.updateTotalPages(data.totalPages);
                }
                this.assetState.updateStateAssets(data.assets, 'All');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
        );
    }

    loadDashboardExploreAssets(loadingAssets: AssetsRequest) {
        this.permissionsService.loadDashboardAssets$(loadingAssets).subscribe(
            (data) => {
                if (loadingAssets.needCount) {
                    this.assetState.updateTotalPages(data.totalPages);
                }
                this.assetState.updateStateAssets(data.assets, 'Dashboard');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
        );
    }

    loadDatasourceExploreAssets(loadingAssets: AssetsRequest) {
        this.permissionsService.loadDataSourceAssets$(loadingAssets).subscribe(
            (data) => {
                if (loadingAssets.needCount) {
                    this.assetState.updateTotalPages(data.totalPages);
                }
                this.assetState.updateStateAssets(data.assets, 'DataSource');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
        );
    }

    loadDashboardGroupExploreAssets(loadingAssets: AssetsRequest): void {
        this.permissionsService.loadDashboardGroupAssets$(loadingAssets).subscribe(
            (data) => {
                if (loadingAssets.needCount) {
                    this.assetState.updateTotalPages(data.totalPages);
                }
                this.assetState.updateStateAssets(data.assets, 'DashboardGroup');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
        );
    }

    loadBookmarkedAssets(loadingAssets: AssetsRequest, type: TabType): void {
        this.assetState.updatePageNumber(loadingAssets.pageNumber);
        switch (type) {
            case 'All':
                this.loadAllBookmarkedAssets(loadingAssets);
                break;
            case 'Dashboard':
                this.loadDashboardBookmarkedAssets(loadingAssets);
                break;
            case 'DataSource':
                this.loadDatasourceBookmarkedAssets(loadingAssets);
                break;
            case 'DashboardGroup':
                this.loadDashboardGroupBookmarkedAssets(loadingAssets);
                break;
        }
    }

    loadAllBookmarkedAssets(loadingAssets: AssetsRequest) {
        this.permissionsService.loadAllAssets$(loadingAssets).subscribe(
            (data) => {
                if (loadingAssets.needCount) {
                    this.assetState.updateTotalPages(data.totalPages);
                }
                this.assetState.updateStateAssets(data.assets, 'All');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
        );
    }

    loadDashboardBookmarkedAssets(loadingAssets: AssetsRequest) {
        this.permissionsService.loadDashboardAssets$(loadingAssets).subscribe(
            (data) => {
                if (loadingAssets.needCount) {
                    this.assetState.updateTotalPages(data.totalPages);
                }
                this.assetState.updateStateAssets(data.assets, 'Dashboard');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
        );
    }

    loadDatasourceBookmarkedAssets(loadingAssets: AssetsRequest) {
        this.permissionsService.loadDataSourceAssets$(loadingAssets).subscribe(
            (data) => {
                if (loadingAssets.needCount) {
                    this.assetState.updateTotalPages(data.totalPages);
                }
                this.assetState.updateStateAssets(data.assets, 'DataSource');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
        );
    }

    loadDashboardGroupBookmarkedAssets(loadingAssets: AssetsRequest): void {
        this.permissionsService.loadDashboardGroupAssets$(loadingAssets).subscribe(
            (data) => {
                if (loadingAssets.needCount) {
                    this.assetState.updateTotalPages(data.totalPages);
                }
                this.assetState.updateStateAssets(data.assets, 'DashboardGroup');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
        );
    }

    loadAssetsMetaData(): void {
      const payload = this.assetState.getAssetMetaDataPayload()
      this.assetApi.getAssetsMetaData(payload).subscribe(
        (response) => {
          this.assetState.setAssetsMetaData(response.data);
        },
        (errorRes) => {
          this.toastr.showError(errorRes.error.message);
        },
      );
    }

    updateAssetMetaDataPayload(payload: AssetMetaDataPayload): void {
        this.assetState.setAssetMetaDataPayload(payload)
    }

    loadDashboardsGroupMetaData(workSpaceID: string, dashboardGroupId: string): void {
      this.assetApi.getDashboardsGroupMetaData(workSpaceID, dashboardGroupId).subscribe(
        (response) => {
          this.assetState.setAssetsMetaData(response.data);
        },
        (errorRes) => {
          this.toastr.showError(errorRes.error.message);
        },
      );
    }

    getAssetsMetaData$(): Observable<AssetsMetaData> {
      return this.assetState.getAssetsMetaData$();
    }

    makeNewDashboard(body: any, workspaceID) {
        body.dashboardDesignSettings = `{"backgroundColor": "#F8F8F8",
                                       "showTitle": true,
                                       "titleBackgroundColor": "#FFFFFF",
                                       "titleColor": "#4D4D4D",
                                       "titleDividerLineColor": "#EDEDED",
                                       "titleFontFamily": "iranyekan",
                                       "titleFontSize": 24,
                                       "toggleFooter": false,
                                       "autoRefreshEnabled": false,
                                       "textFooterColor": "#4D4D4D",
                                       "textFooterAlignment": "Right",
                                       "footerBackground": "#FFFFFF",
                                       "footerBorder": "#FFFFFF",
                                       "footerDividerColor": "#E8E8E8",
                                       "showCreator": false,
                                       "showLastModifiedDataSourceUpdated": false,
                                       "showLastModifiedDashboardUpdated": false,
                                       "showView": false,
                                       "showUsersCountAccessToDashboard": false,
                                       "showCustomText": false,
                                       "footerCustomText": "",
                                       "chipsColor": "#00000099",
                                       "chipsBackgroundColor": "#dddddd",
                                       "version": "0.0.1"}`;
        this.assetApi.makeNewDashboard(body).subscribe(
            (res) => {
                this.router.navigate([`/dashboard/view/${workspaceID}/${res.data.dashboardId}`]);
            },
            (errorRes) => {
                window.alert(errorRes?.error?.message||'خطا در ساخت داشبورد');
            },
        );
    }

    loadHomeAssets(loadingAssets: any, currentPageNumbers?: any, paginatedWorkspace?:any): void {
        this.assetState.setLoadingHomeAssets(true);
        // this.loadHomeMostUsedAssets(loadingAssets);
        // this.loadHomeBookmarkedAssets(loadingAssets);
        this.loadHomeRecentAssets({...loadingAssets, pageNumber: 1});
        // this.loadHomeDashboardGroup({...loadingAssets, pageNumber: (currentPageNumbers['DashboardGroup']||loadingAssets.pageNumber)});
        this.loadHomeDashboardGroup({...loadingAssets, pageNumber: 1});
        // if(!currentPageNumbers?.['Workspace']){
        this.loadHomePaginatedWorkspaces({...loadingAssets, pageNumber: 1});
        // }else{
        //   this.assetState.updateAssetsInfo(paginatedWorkspace);
        //   this.assetState.updatePaginatedHomeUserWorkspacesAssets(paginatedWorkspace);
        //   this.assetState.loadingHomePaginatedWorkspaces = false;
        //   this.assetState.setLoadingHomePaginatedWorkspaces(false);
        //   this.assetState.checkHomeAssetsLoaded();
        // }
        this.loadNewestDashboardUserAccess({...loadingAssets, pageNumber: 1})
    }

    loadHomeDashboardGroup(body: any, previousItems:any = [], cb?:any): void {
      this.assetState.setLoadingHomeGroupDashboardAssets(true);
      this.assetState.updateHomeDashboardGroupAssets([]);
      this.permissionsService.loadHomeDashboardGroup$(body).subscribe((assets: Asset[]) => {
        if(assets) {
          assets.forEach((workspace) => {
            workspace.noPermissionExist = !workspace.permissions.get('Edit').isChecked;
          });
        }
        this.assetState.updateAssetsInfo(assets);
        if(cb){
          cb(assets)
        }
        this.assetState.updateHomeDashboardGroupAssets([...previousItems,...assets]);
        this.assetState.loadingHomeGroupdashboardAssets = false;
        this.assetState.setLoadingHomeGroupDashboardAssets(false);
        // this.assetState.checkHomeAssetsLoaded();
      });
    }

    updateHomeDashboardGroupAssets(assets: Asset[]){
      this.assetState.updateHomeDashboardGroupAssets(assets)
    }

    loadHomePaginatedWorkspaces(body: any): void {
      this.assetState.setLoadingHomePaginatedWorkspaces(true);
      this.permissionsService.loadPaginatedUserWorkspaces$(body).subscribe((assets: Partial<Workspace>[]) => {
        if(assets) {
          assets.forEach((workspace) => {
            workspace.noPermissionExist = !workspace.permissions.get('Edit').isChecked;
          });
        }
        this.assetState.updateAssetsInfo(assets);
        this.assetState.updatePaginatedHomeUserWorkspacesAssets(assets);
        this.assetState.loadingHomePaginatedWorkspaces = false;
        this.assetState.setLoadingHomePaginatedWorkspaces(false);
        // this.assetState.checkHomeAssetsLoaded();
      });
    }

    loadNewestDashboardUserAccess(body: any): void {
      this.assetState.setLoadingNewestDashboardUserAccess(true);
      this.permissionsService.loadNewestDashboardUserAccess$(body).subscribe((assets: Asset[]) => {
        if(assets) {
            assets.forEach((workspace) => {
              workspace.noPermissionExist = !workspace.permissions.get('Edit').isChecked;
            });
          }
          this.assetState.updateAssetsInfo(assets);
          this.assetState.updateNewestDashboardUserAccessAssets(assets);
          this.assetState.loadingNewestDashboardUserAccess = false;
          this.assetState.setLoadingNewestDashboardUserAccess(false);
          // this.assetState.checkHomeAssetsLoaded();
      });
    }

    loadHomeRecentAssets(body: any): void {
      this.assetState.setLoadingHomeRecentAssets(true);
      this.permissionsService.loadHomeRecentAssets$(body).subscribe((assets: Asset[]) => {
        if(assets) {
          assets.forEach((workspace) => {
            workspace.noPermissionExist = !workspace.permissions.get('Edit').isChecked;
          });
        }
        this.assetState.updateAssetsInfo(assets);
        this.assetState.updateHomeRecentAssets(assets);
        this.assetState.loadingHomeRecentAssets = false;
        this.assetState.setLoadingHomeRecentAssets(false);
        // this.assetState.checkHomeAssetsLoaded();
      });
    }

    loadHomeBookmarkedAssets(body: any): void {
        this.permissionsService.loadHomeBookmarkedAssets$(body).subscribe((assets: Asset[]) => {
            this.assetState.updateAssetsInfo(assets);
            this.assetState.updateHomeBookmarkedAssets(assets);
            // this.assetState.loadingHomeBookmarkedAssets = false;
            this.assetState.checkHomeAssetsLoaded();
        });
    }

    loadHomeMostUsedAssets(body: any): void {
        this.permissionsService.loadHomeMostUsedAssets$(body).subscribe((assets: Asset[]) => {
            this.assetState.updateAssetsInfo(assets);
            this.assetState.updateHomeMostUsedAssets(assets);
            // this.assetState.loadingHomeMostUsedAssets = false;
            this.assetState.checkHomeAssetsLoaded();
        });
    }

    loadSelectedDashboardGroup(workspaceId: string, dashboardGroupId: string): void {
        this.permissionsService.loadSelectedDashboardGroup$(workspaceId, dashboardGroupId).subscribe(
            (dashboardGroupInfo) => this.assetState.updateDashboardGroupSelected(dashboardGroupInfo),
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
        );
    }

    loadDashboardsOfDashboardGroup(loadingAssets: AssetsRequest): void {
        this.permissionsService.loadDashboardAssets$(loadingAssets).subscribe(
            (data) => {
                if (loadingAssets.needCount) {
                    this.assetState.updateTotalPages(data.totalPages);
                }
                this.assetState.updateStateAssets(data.assets, 'Dashboard');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
        );
    }

    loadDashboardsForAddToGroup(workspaceId: string, dashboardGroupId: string): void {
        this.permissionsService.loadDashboardsForAddToGroup(workspaceId, dashboardGroupId).subscribe(
            (dashboards) => this.assetState.updateDashboardsForAddToGroup(dashboards),
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            });
    }

    getDashboardsForAddToGroup$(): Observable<Asset[]> {
        return this.assetState.getDashboardsForAddToGroup$();
    }

    loadDatasourceList(loadingAssets: AssetsRequest, resetList: boolean): void {
      this.permissionsService.getDataSourceExplore(loadingAssets).pipe(map(res => res.data)).subscribe(
        (data: DataSourceExplore) => {
          if (resetList) {
            this.assetState.setDataSourceList(data);
          } else {
            this.assetState.updateDataSourceList(data);
          }
        },
        (errorRes) => {
          this.toastr.showError(errorRes.error.message);
        },
      );
    }

    getDatasourceList$(): Observable<DataSourceExplore> {
      return this.assetState.getDatasourceList$();
    }

    createDashboardGroup(dashboardGroupName: string, workspaceId: string, section: AssetSection): void {
        this.setSubmitState('submitting');
        this.assetApi.createDashboardGroup(dashboardGroupName, workspaceId).subscribe(
            (res: any) => {
                this.toastr.showSuccess('گروه داشبوردی با موفقیت ساخته شد.');
                this.router.navigate(['/home/dashboardGroup', workspaceId, res.data],
                    {queryParams: {assetSection: section}});
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
                this.setSubmitState('submitted');
            },
        );
    }

    updateStateAssets(data: any, tabType: TabType) {
        this.assetState.updateStateAssets(data, tabType);
    }

    addDashboardsToGroup(dashboardGroupInfo: DashboardGroupInfo, dashboardIds: string[], pageSize: number): void {
        this.setSubmitState('submitting');
        this.assetApi.addDashboardToGroup(dashboardGroupInfo, dashboardIds).subscribe(
            () => {
                this.toastr.showSuccess('عملیات باموفقیت انجام شد.');
                this.assetState.addDashboardsToDashboardGroup(dashboardIds, pageSize, dashboardGroupInfo);
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
                this.setSubmitState('submitted');
            },
        );
    }

    updateDatasourceData(updateDatasource: any): void {
        this.assetApi.updateDatasourceData(updateDatasource).subscribe(
            () => {
            },
            () => {
            },
            () => {
            },
        );
    }

    duplicateDatasource(workspaceId: string, dataSourceId: string, dataSourceName: string,
        loadingAssets: AssetsRequest, selectedTab: TabType): void {
        const infoToster = this.toastr.showInfo(`در حال کپی منبع داده “${dataSourceName}”`, null);
        this.assetApi.duplicateDatasource(workspaceId, dataSourceId).subscribe(
            (res) => {
                this.toastr.removeToast(infoToster.toastId);
          
                if (res?.data?.hasError) {
                    const errors = res.data.errorMessages?.filter((e) => !!e) || [];
                    let message = 'برخی ستون‌ها در منبع‌داده جدید کپی نمی‌شوند.<br>';
            
                    if (errors.length > 0) {
                      errors.forEach((err, index) => {
                        message += `${index + 1}. ${err}<br>`;
                      });
                    }
            
                    message += 'لطفاً در صورت نیاز آن‌ها را مجدداً ایجاد کنید.';
            
                    const dialogRef = this.dialogService.open(MessageDialogComponent, {
                      closeOnBackdropClick: false,
                      context: {
                        icon: 'warning',
                        title: 'اخطار',
                        dialogMode: 'simple-warning',
                        message,
                      },
                    });
          
                  dialogRef.onClose.subscribe(() => {
                    this.loadExploreAssets(loadingAssets, selectedTab);
                    this.loadAssetsMetaData();
                    this.progressService.closeModal();
                    this.progressService.openModal();
                  });
                } else {
                  this.loadExploreAssets(loadingAssets, selectedTab);
                  this.loadAssetsMetaData();
                  this.progressService.closeModal();
                  this.progressService.openModal();
                }
              },
          
            (errorRes) => {
                this.toastr.removeToast(infoToster.toastId);
                this.toastr.showError(errorRes.error.message);
            },
        );
    }

    updateDatasourceName(newDatasource: any, asset: Asset): void {
        this.setSubmitState('submitting');
        this.assetApi.updateDatasourceName(newDatasource).subscribe(
            () => {
                this.assetState.updateAsset(asset, 'DataSource');
                this.toastr.showSuccess('نام منبع داده با موفقیت تغییر پیدا کرد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
                this.setSubmitState('notSubmitted');
            },
            () => {
                this.setSubmitState('submitted');
            },
        );
    }

    updateDashboardName(dashboard: any, asset: Asset): void {
         this.assetApi.updateDashboardName(dashboard).subscribe(
          (data) => {
              if (data.data.statusCode === 'ObjectAlreadyExists') {
                this.assetState.setDashboardNameDuplicated(true);
                this.setSubmitState('duplicateName');
                // dashboard.dashboardDesignSettings.dashboardRichName = data.data.richName
              } else {
                this.setSubmitState('submitted');
                this.assetState.setDashboardNameDuplicated(false);
                this.assetState.updateAsset(asset, 'Dashboard');
                this.toastr.showSuccess('نام داشبورد با موفقیت تغییر پیدا کرد.');
  
              }
          },
          (errorRes) => {
              this.assetState.setDashboardNameDuplicated(false);
              this.toastr.showError(errorRes.error.message);
              this.setSubmitState('notSubmitted');
            
          },
        );
    }

    updateDashboardGroupName(newDashboardGroup: any, asset: Asset): void {
        this.setSubmitState('submitting');
        this.assetApi.updateDashboardGroup(newDashboardGroup).subscribe(
            () => {
                this.assetState.updateAsset(asset, 'DashboardGroup');
                this.toastr.showSuccess('نام گروه داشبوردی با موفقیت تغییر پیدا کرد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
                this.setSubmitState('notSubmitted');
            },
            () => {
                this.setSubmitState('submitted');
            },
        );
    }

    updateHomeDatasourceName(newDatasource: any, asset: any): void {
        this.setSubmitState('submitting');
        this.assetApi.updateDatasourceName(newDatasource).subscribe(
            () => {
                this.assetState.updateHomeMostUsedAsset(asset);
                this.assetState.updateHomeRecentAsset(asset);
                this.assetState.updateHomeBookmarkedAsset(asset);
                this.toastr.showSuccess('نام منبع داده با موفقیت تغییر پیدا کرد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
                this.setSubmitState('notSubmitted');
            },
            () => {
                this.setSubmitState('submitted');
            },
        );
    }

    updateHomeDashboardName(newDashboard: any, asset: any): void {
        this.setSubmitState('submitting');
        this.assetApi.updateDashboardName(newDashboard).subscribe(
            (data) => {
              // console.log(newDashboard, asset);
              // this.assetState.updateHomeMostUsedAsset(asset);
              //   this.assetState.updateHomeRecentAsset(asset);
                // this.assetState.updateHomeBookmarkedAsset(asset);
            this.assetState.setDashboardNameDuplicated(false);
            
              if (data.data.statusCode === 'ObjectAlreadyExists') {
                this.assetState.setDashboardNameDuplicated(true);
                this.setSubmitState('duplicateName');
              } else {
                this.assetState.setDashboardNameDuplicated(false);
                this.setSubmitState('submitted');
                if(asset?.entityType === 'homeNewestAccess'){
                    this.assetState.updateNewestDashboardUserAccessAsset(asset);
                  }else if(asset?.entityType === 'homeRecent'){
                    this.assetState.updateHomeRecentAsset(asset);
                  }
              }
              this.toastr.showSuccess('نام داشبورد با موفقیت تغییر پیدا کرد.');
            },
            (errorRes) => {
                
                    this.assetState.setDashboardNameDuplicated(false);
                    this.toastr.showError(errorRes.error.message);
                    this.setSubmitState('notSubmitted');
                  
            },
        );
    }

    updateHomeDashboardGroupName(newDashboardGroup: any, asset: Asset): void {
        this.setSubmitState('submitting');
        this.assetApi.updateDashboardGroup(newDashboardGroup).subscribe(
          () => {
            console.log(asset);
            // this.assetState.updateHomeBookmarkedAsset(asset);
            // this.assetState.updateHomeMostUsedAsset(asset);
            // this.assetState.updateHomeRecentAsset(asset);
            this.assetState.updateHomeDashboardGroupAsset(asset);
                this.toastr.showSuccess('نام گروه داشبوردی با موفقیت تغییر پیدا کرد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
                this.setSubmitState('notSubmitted');
            },
            () => {
                this.setSubmitState('submitted');
            },
        );
    }

    activateHomeDashboard(asset: Asset): void {
        this.assetApi.activeDashboard(asset.workspaceId, asset.assetId).subscribe(
            () => {
                asset.cardOptions = this.assetState.getDashboardCardOptions(asset);
                this.assetState.updateHomeMostUsedAsset(asset);
                this.assetState.updateHomeRecentAsset(asset);
                this.assetState.updateHomeBookmarkedAsset(asset);
                this.toastr.showSuccess('داشبورد با موفقیت فعال شد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
                this.updateSubmitting(false);
            },
        );
    }

    deactivateHomeDashboard(asset: Asset): void {
        this.assetApi.deActiveDashboard(asset.workspaceId, asset.assetId).subscribe(
            () => {
                asset.cardOptions = this.assetState.getDashboardCardOptions(asset);
                this.assetState.updateHomeMostUsedAsset(asset);
                this.assetState.updateHomeRecentAsset(asset);
                this.assetState.updateHomeBookmarkedAsset(asset);
                this.toastr.showSuccess('داشبورد غیرفعال شد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
                this.updateSubmitting(false);
            },
        );
    }

    activateDashboard(asset: Asset): void {
        this.assetApi.activeDashboard(asset.workspaceId, asset.assetId).subscribe(
            () => {
                asset.cardOptions = this.assetState.getDashboardCardOptions(asset);
                this.assetState.updateAsset(asset, 'Dashboard');
                this.toastr.showSuccess('داشبورد با موفقیت فعال شد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
                this.updateSubmitting(false);
            },
        );
    }

    deactivateDashboard(asset: Asset): void {
        this.assetApi.deActiveDashboard(asset.workspaceId, asset.assetId).subscribe(
            () => {
                asset.cardOptions = this.assetState.getDashboardCardOptions(asset);
                this.assetState.updateAsset(asset, 'Dashboard');
                this.toastr.showSuccess('داشبورد غیرفعال شد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
                this.updateSubmitting(false);
            },
        );
    }

    deleteExploreAssets(assets: any, loadingAssets: AssetsRequest, type: TabType): void {
        this.setSubmitState('submitting');
        this.assetApi.deleteAssets(assets).subscribe(
            (res) => {
                this.toastr.showSuccess('عملیات حذف با موفقیت انجام شد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
                this.setSubmitState('submitted');
                this.loadExploreAssets(loadingAssets, type);
            },
        );
    }

    deleteBookmarkedAssets(assets: any, loadingAssets: AssetsRequest, type: TabType) {
        this.setSubmitState('submitting');
        this.assetApi.deleteAssets(assets).subscribe(
            (res) => {
                this.toastr.showSuccess('عملیات حذف با موفقیت انجام شد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
                this.setSubmitState('submitted');
                this.loadBookmarkedAssets(loadingAssets, type);
            },
        );
    }

    deleteHomeAsset(asset: any, loadingHomeAssets: any): void {
        this.setSubmitState('submitting');
        this.assetApi.deleteAssets(asset).subscribe(
            () => {
                this.loadHomeAssets(loadingHomeAssets);
                this.toastr.showSuccess('عملیات حذف با موفقیت انجام شد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
                this.setSubmitState('submitted');
            },
        );
    }

    removeDashboardFromGroup(dashboards: Asset[], loadingAssets: any): void {
        this.setSubmitState('submitting');
        this.assetApi.removeDashboardFromGroup(loadingAssets, dashboards).subscribe(
            () => {
                this.loadDashboardsOfDashboardGroup(loadingAssets);
                this.toastr.showSuccess('عملیات حذف از گروه داشبوردی با موفقیت انجام شد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
                this.setSubmitState('submitted');
            },
        );
    }

    removeDashboardFromGroupAndAssets(assets: any, loadingAssets: any): void {
        this.setSubmitState('submitting');
        this.assetApi.deleteAssets(assets).subscribe(
            (res) => {
                this.loadDashboardsOfDashboardGroup(loadingAssets);
                this.toastr.showSuccess('عملیات حذف با موفقیت انجام شد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
                this.setSubmitState('submitted');
            },
        );
    }

    updateTotalPages(totalPages: number) {
        this.assetState.updateTotalPages(totalPages);
    }

    addBookmarkExploreDatasource(newAsset: any, asset: Asset): void {
        this.assetState.updateAsset(asset, 'DataSource');
        this.assetState.updateAsset(asset, 'All');
        this.assetApi.addBookmark(newAsset).subscribe(
            () => {
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
                this.assetState.rollBackAsset('All');
                this.assetState.rollBackAsset('DataSource');
            },
            () => {
            },
        );
    }

    removeBookmarkExploreDatasource(newAsset: any, asset: Asset): void {
        this.assetState.updateAsset(asset, 'DataSource');
        this.assetState.updateAsset(asset, 'All');
        this.assetApi.removeBookmark(newAsset).subscribe(
            () => {
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
                this.assetState.rollBackAsset('All');
                this.assetState.rollBackAsset('DataSource');
            },
            () => {
            },
        );
    }

    addBookmarkExploreDashboard(newAsset: any, asset: Asset): void {
        this.assetState.updateAsset(asset, 'Dashboard');
        this.assetState.updateAsset(asset, 'All');
        this.assetApi.addBookmark(newAsset).subscribe(
            () => {
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
                this.assetState.rollBackAsset('All');
                this.assetState.rollBackAsset('Dashboard');
            },
            () => {
            },
        );
    }

    removeBookmarkExploreDashboard(newAsset: any, asset: Asset): void {
        this.assetState.updateAsset(asset, 'Dashboard');
        this.assetState.updateAsset(asset, 'All');
        this.assetApi.removeBookmark(newAsset).subscribe(
            () => {
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
                this.assetState.rollBackAsset('All');
                this.assetState.rollBackAsset('Dashboard');
            },
            () => {
            },
        );
    }

    addBookmarkExploreDashboardGroup(newAsset: any, asset: Asset): void {
        this.assetState.updateAsset(asset, 'DashboardGroup');
        this.assetState.updateAsset(asset, 'All');
        this.assetApi.addBookmark(newAsset).subscribe(
            () => {
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
                this.assetState.rollBackAsset('All');
                this.assetState.rollBackAsset('DashboardGroup');
            },
            () => {
            },
        );
    }

    removeBookmarkExploreDashboardGroup(newAsset: any, asset: Asset): void {
        this.assetState.updateAsset(asset, 'DashboardGroup');
        this.assetState.updateAsset(asset, 'All');
        this.assetApi.removeBookmark(newAsset).subscribe(
            () => {
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
                this.assetState.rollBackAsset('All');
                this.assetState.rollBackAsset('DashboardGroup');
            },
            () => {
            },
        );
    }

    datasourceAssetRemoveBookmark(newAsset: any, asset: Asset): void {
        this.assetApi.removeBookmark(newAsset).subscribe(
            () => {
                this.assetState.removeBookmarkedAsset('DataSource', asset);
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
            },
        );
    }

    dashboardAssetRemoveBookmark(newAsset: any, asset: Asset): void {
        this.assetApi.removeBookmark(newAsset).subscribe(
            () => {
                this.assetState.removeBookmarkedAsset('Dashboard', asset);
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
            },
        );
    }

    dashboardGroupRemoveBookmark(newAsset: any, asset: Asset): void {
        this.assetApi.removeBookmark(newAsset).subscribe(
            () => {
                this.assetState.removeBookmarkedAsset('DashboardGroup', asset);
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
            },
        );
    }

    removeHomeBookmark(asset: Asset) {
        this.assetState.removeHomeBookmarkedAsset(asset);
        this.assetApi.removeBookmark(asset).subscribe(
            () => {
                // const reloadAssets = {
                //     bookmarkBOType: 'None',
                //     workspaceId: asset.workspaceId,
                //     takeNumber: 6,
                // };
                // this.loadHomeBookmarkedAssets(reloadAssets);
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
                this.assetState.rollBackHomeAssets();
            },
            () => {
            },
        );
    }

    addHomeBookmark(asset: Asset) {
        this.assetState.addHomeBookmarkedAsset(asset);
        this.assetApi.addBookmark(asset).subscribe(
            () => {
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
                this.assetState.rollBackHomeAssets();
            },
            () => {
            },
        );
    }

    uploadImageDashboard(uploadType: any, formFile: any, asset: Asset, assetSection: AssetSection = 'Default') {
        this.assetApi.uploadFile(uploadType, formFile, asset.workspaceId).subscribe(
            (res: any) => {
                const imagePath = res.data.path;
                this.updateDashboardImagePath(asset, imagePath, assetSection);
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
            },
        );
    }

    updateDashboardImagePath(asset: any, path: any, assetSection: AssetSection) {
        this.assetApi.updateDashboardImage(asset.workspaceId, asset.assetId, path).subscribe(
            () => {
                asset.imagePath = path !== null ? `${environment.api}/File/Download?path=${path}` :
                    'assets/images/dashboard.png';
              console.log(asset, assetSection);
              if(asset.entityType === 'homeNewestAccess'){
                this.assetState.updateNewestDashboardUserAccessAsset(asset)
              }else if(asset.entityType === 'homeRecent'){
                this.assetState.updateHomeRecentAsset(asset)
              }else if (assetSection === 'Home') {
                      this.assetState.updateHomeMostUsedAsset(asset);
                      this.assetState.updateHomeRecentAsset(asset);
                      this.assetState.updateHomeBookmarkedAsset(asset);
                     this.assetState.updateAsset(asset, 'Dashboard');
                } else if (assetSection === 'Default') {
                    this.assetState.updateAsset(asset, 'Dashboard');
                }
                this.toastr.showSuccess('تغییرات ذخیره شد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
            },
        );
    }

    // eslint-disable-next-line max-len
    uploadImageDataSource(uploadType: string, formFile: FormData, asset: Asset,
                          assetSection: AssetSection = 'Default'): void {
        this.assetApi.uploadFile(uploadType, formFile, asset.workspaceId).subscribe(
            (res: any) => {
                const imagePath = res.data.path;
                this.updateDataSourceImagePath(asset, imagePath, assetSection);
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
            },
        );
    }

    updateDataSourceImagePath(asset: Asset, path: any, assetSection: AssetSection): void {
        this.assetApi.updateDataSourceImage(asset.workspaceId, asset.assetId, path).subscribe(
            () => {
                asset.imagePath = path !== null ? `${environment.api}/File/Download?path=${path}` :
                    'assets/images/datasource.png';
                if (assetSection === 'Home') {
                    this.assetState.updateHomeMostUsedAsset(asset);
                    this.assetState.updateHomeRecentAsset(asset);
                    this.assetState.updateHomeBookmarkedAsset(asset);
                } else if (assetSection === 'Default') {
                    this.assetState.updateAsset(asset, 'DataSource');
                }
                this.toastr.showSuccess('تغییرات ذخیره شد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
            },
        );
    }

    uploadImageDashboardGroup(uploadType: string, formFile: FormData, asset: Asset,
                              assetSection: AssetSection = 'Default'): void {
        this.assetApi.uploadFile(uploadType, formFile, asset.workspaceId).subscribe(
            (res: any) => {
                const imagePath = res.data.path;
                this.updateDashboardGroupImagePath(asset, imagePath, assetSection);
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
            },
        );
    }

    updateDashboardGroupImagePath(asset: Asset, path: any, assetSection: AssetSection): void {
        this.assetApi.updateDashboardGroupImage(asset.workspaceId, asset.assetId, path).subscribe(
            () => {
                asset.imagePath = path !== null ? `${environment.api}/File/Download?path=${path}` :
                    'assets/images/dashboard-group.png';
                if (assetSection === 'Home') {
                  // this.assetState.updateHomeBookmarkedAsset(asset);
                  // this.assetState.updateHomeMostUsedAsset(asset);
                  // this.assetState.updateHomeRecentAsset(asset);
                  this.assetState.updateHomeDashboardGroupAsset(asset);
                } else if (assetSection === 'Default') {
                    this.assetState.updateAsset(asset, 'DashboardGroup');
                }
                this.toastr.showSuccess('تغییرات ذخیره شد.');
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
            () => {
            },
        );
    }

    updateSubmitting(isSubmitting: boolean): void {
        this.assetState.updateSubmitting(isSubmitting);
    }

    setSubmitState(submit: SubmitType): void {
        this.assetState.setSubmitState(submit);
    }

    getSubmitState$(): Observable<SubmitType> {
        return this.assetState.getSubmitState$();
    }

    getAllAssets$(): Observable<Asset[]> {
        return this.assetState.getAllAssets$();
    }

    getDashboardAssets$(): Observable<Asset[]> {
        return this.assetState.getDashboardAssets$();
    }

    getDataSourceAssets$(): Observable<Asset[]> {
        return this.assetState.getDataSourceAssets$();
    }

    getDashboardGroupAssets$(): Observable<Asset[]> {
        return this.assetState.getDashboardGroupAssets$();
    }

    getHomeRecentAssets$(): Observable<Asset[]> {
        return this.assetState.getHomeRecentAssets$();
    }

    getHomeBookmarkedAssets$(): Observable<Asset[]> {
        return this.assetState.getHomeBookmarkedAssets$();
    }

    getHomeMostUsedAssets$(): Observable<Asset[]> {
        return this.assetState.getHomeMostUsedAssets$();
    }
    getNewestDashboardUserAccess$(): Observable<Asset[]> {
        return this.assetState.getNewestDashboardUserAccess$();
    }

    getHomeDashboardGroupAssets$(): Observable<Asset[]>{
      return this.assetState.getHomeDashboardGroupAssets$();
    }
    getPaginatedUserWorkspaces$(): Observable<Partial<Workspace>[]>{
        return this.assetState.getPaginatedUserWorkspaces$();
      }
    getDashboardGroupSelected$(): Observable<DashboardGroupInfo> {
        return this.assetState.getDashboardGroupSelected$();
    }

    getTotalPages$(): Observable<any> {
        return this.assetState.getTotalPages$();
    }

    getPageNumber$(): Observable<any> {
        return this.assetState.getPageNumber$();
    }

    getSubmitting$(): Observable<any> {
        return this.assetState.getSubmitting$();
    }

    getLoadingHomeAssets$(): Observable<boolean> {
        return this.assetState.getLoadingHomeAssets$();
    }
    getLoadingHomeGroupDashboardAssets$(): Observable<boolean> {
        return this.assetState.getloadingHomeGroupDashboardAssets$();
    }

    getLoadingNewestDashboardUserAccess$(): Observable<boolean> {
        return this.assetState.getLoadingNewestDashboardUserAccess$();
    }

    getLoadingHomeRecentAssets$(): Observable<boolean> {
        return this.assetState.getLoadingHomeRecentAssets$();
    }

    getLoadingHomePaginatedWorkspaces$(): Observable<boolean> {
        return this.assetState.getLoadingHomePaginatedWorkspaces$();
    }

    setDashboardAssets(assets: Asset[]) {
        this.assetState.updateStateAssets(assets, 'Dashboard');
    }

    loadDashboardGroupsForMove(workspaceId: string, dashboardId: string): void {
        this.assetApi.getDashboardGroupsForMove(workspaceId, dashboardId).subscribe(
            (res) => this.assetState.updateDashboardGroupsForMove(res.data),
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
        );
    }

    getDashboardGroupsForMove$(): Observable<DashboardGroup[]> {
        return this.assetState.getDashboardGroupsForMove$();
    }

    moveDashboardToGroup(workspaceId: string, dashboardGroup: DashboardGroup, dashboardId: string,
                         isDashboardOfDashboardGroup: boolean, loadingAssets: AssetsRequest): void {
        this.setSubmitState('submitting');
        this.assetApi.moveDashboardToGroup(workspaceId, dashboardGroup.id, dashboardId).subscribe(
            () => {
                this.toastr.showSuccess('انتقال با موفقیت انجام شد.');
                if (isDashboardOfDashboardGroup) {
                    this.loadDashboardsOfDashboardGroup(loadingAssets);
                } else {
                    this.assetState.updateDashboardAsset(dashboardGroup, dashboardId);
                }
            },
            () => this.toastr.showError('عملیات انتفال ناموفق بود.'),
            () => this.setSubmitState('submitted'),
        );
    }

    getWelcomeMessage$(): Observable<WelcomeMessageModel> {
        return this.assetState.getWelcomeMessage$();
    }

    loadUserWelcomeMessage$(workspaceId: string): void {
        this.assetApi.getWelcomeMessage(workspaceId).subscribe(
            (welcomeMessage) => {
                this.assetState.setWelcomeMessage(welcomeMessage.data);
            },
            (errorRes) => {
                this.toastr.showError(errorRes.error.message);
            },
        );
    }

    dashboardDuplicate(
        workspaceId: string,
        dashboardId: string,
        dashboardName: string,
        dashboardGroupId: string = undefined
      ): void {
        const infoToster = this.toastr.showInfo(`در حال کپی داشبورد “${dashboardName}”`, null);
        this.assetApi.duplicateDashboard(workspaceId, dashboardId, dashboardGroupId).subscribe(
          (response) => {
            this.toastr.removeToast(infoToster.toastId);
            if (response?.data?.hasError) {
                const dialogRef = this.dialogService.open(MessageDialogComponent, {
                closeOnBackdropClick: false,
                context: {
                  message: 'برخی از معیارها دارای خطا هستند و در داشبورد جدید کپی نمی‌شوند.',              
                  messageDetail: 'نمودارهای وابسته در داشبورد جدید با خطا مواجه خواهند شد.',
                  errorsList: response.data.errors,
                  errorsListTitle: 'موارد خطا (' + response.data.errors.length + ')',
                  icon: 'error',
                  title: 'اخطار',
                },
              });
              dialogRef.onClose.subscribe(() => {
                this.toastr.showSuccess('داشبورد تکرارشده بدون اعمال مجوز داشبورد اصلی با موفقیت ایجاد شد.');
                this.setSubmitState('needReload');    
              });
            }
            else {
            this.toastr.showSuccess('داشبورد تکرارشده بدون اعمال مجوز داشبورد اصلی با موفقیت ایجاد شد.');
            this.setSubmitState('needReload');
            }
          },
          (errorRes) => {
            this.toastr.removeToast(infoToster.toastId);
            this.toastr.showError(errorRes.error.message);
          },
        );
       }

    updateDashboardPinStatus(dashboardId: string, sortOrder: SortOrder) {
              return this.assetApi.updateDashboardPinStatus(dashboardId)
          }

          updateDashboardGroupPinStatus(dashboardGroupId: string, sortOrder: SortOrder) {
              return this.assetApi.updateDashboardGroupPinStatus(dashboardGroupId)
          }
          setDashboardDuplicatedName(value : boolean){
            this.assetState.setDashboardNameDuplicated(value)
    }

    exportDashboard(workspaceId: string, dashboardId: string): void {
        this.assetApi.exportDashboard(workspaceId, dashboardId).subscribe(
          res => {
            const fullPath = res.data; // "ExportDashboardFiles/1404-11-12_17-47-30.tart"
            const cleanFileName = fullPath.split('/').pop() || '';
      
            fetch(this.baseAddress + fullPath)
              .then(r => r.blob())
              .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = cleanFileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
              })
              .catch(() => {
                this.dialogService.open(ExportWarningModalComponent, {
                  closeOnBackdropClick: false,
                  context: {
                    messageOne: 'این داشبورد به دلیل وجود خطا در منبع داده یا ساختار کارت‌ها قابل خروجی گرفتن نیست.',
                    messageTwo: 'برای ادامه، ابتدا خطاهای داشبورد را برطرف کنید.'
                  }
                });
              });
          },
          err => {
            this.dialogService.open(ExportWarningModalComponent, {
              closeOnBackdropClick: false,
              context: {
                messageOne: 'این داشبورد به دلیل وجود خطا در منبع داده یا ساختار کارت‌ها قابل خروجی گرفتن نیست.',
                messageTwo: 'برای ادامه، ابتدا خطاهای داشبورد را برطرف کنید.'
              }
            });
          }
        );
      }
                       
}
